export default __webpack_public_path__ + "static/media/3-100.96dd99d1.jpg";